export default [
	{
		type: 'trap',
		slug: 'pikes-trap',
		targets: [ 'empty' ],
		fr: {
			name: "Piège à piques",
			description: "Inflige 1 point de dégât."
		},
		en: {
			name: "Spikes trap",
			description: "Inflicts 1 point of damage."
		}
	},
	{
		type: 'trap',
		slug: 'wolf-trap',
		targets: [ 'empty' ],
		fr: {
			name: "Piège à loup",
			description: "Retire 1 point de durabilité à vos équipements."
		},
		en: {
			name: "Wolf trap",
			description: "Removes 1 point of durability from your equipment."
		}
	},
	{
		type: 'trap',
		slug: 'puddle',
		targets: [ 'empty' ],
		fr: {
			name: "Flaque d'huile",
			description: "Ajoute 1 carte potion de poison à votre main."
		},
		en: {
			name: "Oil puddle",
			description: "Adds 1 potion of poison to your hand."
		}
	},
]